import { Vue, Component } from 'vue-property-decorator';
import ProductsOrdered from 'components/ProductOrderedTable/template.vue';

@Component({
	components: {
		ProductsOrdered,
	},
})
export default class PricingTable extends Vue {}
